module.exports = __webpack_public_path__ + "static/media/hover_image_coupon.07880f5d.png";